import getStartAndEndOfDay from "@/common/function/getStartAndEndOfDay";
import * as userRequest from "@/utils/userRequest";

interface QueryParams {
    startDate: string;
    endDate: string;
    timezone: string;
}

export default async function getPortfolioTotalAmount(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any,
    queryParams?: QueryParams
) {
    try {
        const res = await userRequest.post(
            "portfolio/wallet-chart",
            {
                startDate: queryParams?.startDate,
                endDate: queryParams?.endDate,
                timezone: queryParams?.timezone,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        console.log("🚀 ~ getPortfolioTotalAmount ~ res:", res);
        if (true || res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.log("🚀 ~ getPortfolioTotalAmount ~ err:", err);
        handleError && handleError(err);
    }
}
